import { render, staticRenderFns } from "./recruitment-fusion-doughnut-card.vue?vue&type=template&id=ded0a66a&"
import script from "./recruitment-fusion-doughnut-card.vue?vue&type=script&lang=js&"
export * from "./recruitment-fusion-doughnut-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "recruitment-fusion-doughnut-card.vue"
export default component.exports